"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mulTemplate = exports.divTemplate = exports.withCondition = exports.aliasExprTemplate = exports.countMultiValueMultiTemplate = exports.countMultiTemplate = exports.valueMultiTemplate = exports.multiTemplate = exports.countMultiValueTemplate = exports.valueTemplate = exports.sumTemplate = exports.countTemplate = exports.subTemplate = exports.sumDimensionTemplate = void 0;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const lodash_get_1 = __importDefault(require("lodash.get"));
const sumDimensionTemplate = (dimensionId) => {
    return {
        expr: {
            $sum: {
                args: [dimensionId],
            },
        },
    };
};
exports.sumDimensionTemplate = sumDimensionTemplate;
const subTemplate = (arg1, arg2) => {
    return {
        expr: {
            $sub: {
                args: [arg1, arg2],
            },
        },
    };
};
exports.subTemplate = subTemplate;
const countTemplate = (eventName) => {
    return {
        expr: {
            $sum: {
                args: ["EVENT_COUNT"],
                where: [{ $eq: ["EVENT_NAME", eventName] }],
            },
        },
    };
};
exports.countTemplate = countTemplate;
const sumTemplate = (eventName) => {
    return {
        expr: {
            $sum: {
                args: ["EVENT_SUM"],
                where: [{ $eq: ["EVENT_NAME", eventName] }],
            },
        },
    };
};
exports.sumTemplate = sumTemplate;
const valueTemplate = (eventName) => {
    return {
        expr: {
            $sum: {
                args: ["EVENT_VALUE"],
                where: [{ $eq: ["EVENT_NAME", eventName] }],
            },
        },
    };
};
exports.valueTemplate = valueTemplate;
const countMultiValueTemplate = (eventName) => ({
    expr: {
        $sum: {
            args: [
                {
                    expr: {
                        $COUNT_MUL_VALUE: {},
                    },
                },
            ],
            where: [{ $eq: ["EVENT_NAME", eventName] }],
        },
    },
});
exports.countMultiValueTemplate = countMultiValueTemplate;
const countMultiValue = {
    expr: {
        $COUNT_MUL_VALUE: {},
    },
};
const multiTemplate = (kind) => (eventNamesArr) => ({
    expr: {
        $sum: {
            args: [kind],
            where: [{ $in: ["EVENT_NAME", eventNamesArr] }],
        },
    },
});
exports.multiTemplate = multiTemplate;
exports.valueMultiTemplate = (0, exports.multiTemplate)("EVENT_VALUE");
exports.countMultiTemplate = (0, exports.multiTemplate)("EVENT_COUNT");
exports.countMultiValueMultiTemplate = (0, exports.multiTemplate)(countMultiValue);
const aliasExprTemplate = (alias) => ({
    expr: { [alias]: {} },
});
exports.aliasExprTemplate = aliasExprTemplate;
// add condition inside deeply nested expression
const withCondition = ({ expr }, condition, innerExprPath) => {
    if (condition) {
        const newExpr = (0, lodash_clonedeep_1.default)(expr);
        if (!innerExprPath) {
            newExpr["$sum"].where.push(condition);
        }
        else {
            (0, lodash_get_1.default)(newExpr, innerExprPath).where.push(condition);
        }
        return { expr: newExpr };
    }
    return { expr };
};
exports.withCondition = withCondition;
const divTemplate = (arg1, arg2) => ({
    expr: {
        $div: {
            args: [arg1, arg2],
        },
    },
});
exports.divTemplate = divTemplate;
const mulTemplate = (arg1, arg2) => ({
    expr: {
        $mul: {
            args: [arg1, arg2],
        },
    },
});
exports.mulTemplate = mulTemplate;
